<script setup>
    
    import { tagsFilterHandles } from '~/utilities/airtable/map.utils';
    
    const props = defineProps({
        session: {
            type: Object,
            required: true
        },
        tags: {
            type: Array,
            required: true
        }
    })

    const handleTagClick = (handle, tag) => {
        const link = `/sessions?tags=${tag.id}#grid`;
        navigateTo(link, { external: false });
    };
    
</script>
<template>
    <div class="session-tags-list tags">
        <template v-for="(handle, key) in tagsFilterHandles" :key="handle">
            <template v-if="session[handle] && session[handle].length > 0">
                <MessLink v-for="tag in session[handle]" :href="`/sessions?tags=${session[handle][0].id}`" :label="tag.name">
                    <ProjectTag colorSet="meteor-transparent" :key="tag.id" :text="tag.name" :useHover="true" :useX="false" @click.prevent="handleTagClick(handle, tag)" :gtmEventName="'session_tag_clicked'" />
                </MessLink>
            </template>
        </template>
    </div>
</template>

<style lang="scss">
    .session-tags-list.tags {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 1.125rem;
        
        .project-tag {
            color: var(--teal-light);
            padding: 0;
            border: none;
            text-decoration: underline;
            text-underline-offset: 0.25rem;
            letter-spacing: 0.034375rem;

            &:hover, &:focus {
                color: var(--orange-dark);
                background: transparent;
                text-decoration: none;
            }
        }
    }
</style>